import React from 'react'
import { useDispatch } from 'react-redux'

import { Button } from 'components'
import ModalGeneric from '../ModalGeneric'

import { hideModal } from '../../../../redux/actions'

import tissClaimNumberImage from '../../../../static/images/tiss-claim-number.png'

import * as S from './styles'

interface AuthorizationGuideExampleModalProps {
  btnText?: string;
  handleClick?: () => void;
  onClose?: () => void;
}

export function AuthorizationGuideExampleModal({
  btnText = 'ENTENDI',
  handleClick,
  onClose
}: AuthorizationGuideExampleModalProps): JSX.Element {
  const dispatch = useDispatch()

  const onCloseModal = () => {
    dispatch(hideModal())
    onClose && onClose()
  }

  const handleButtonClick = () => {
    if (handleClick) {
      handleClick()
    }
    onCloseModal()
  }

  return (
    <ModalGeneric
      modalTitle="Exemplo de guia de autorização"
      onCloseModal={onCloseModal}
      btnText={btnText}
      btnOnClick={handleButtonClick}
      hasButton
      hasCloseButton
    >
      <S.ModalContent>
        <S.ImageContainer>
          <img
            src={tissClaimNumberImage}
            alt="Exemplo de guia de autorização com destaque para o número da guia"
          />
        </S.ImageContainer>

        <S.FirstInstruction>
          Digite atentamente cada um dos números da guia.
        </S.FirstInstruction>

        <S.SecondInstruction>
          Essa informação deve constar entre os primeiros campos do documento.
        </S.SecondInstruction>
      </S.ModalContent>
    </ModalGeneric>
  )
}
